export default __webpack_public_path__ + "static/media/download.1fc4d084.svg";